'use strict';

import { ConfirmAppointment } from "../../actions/appointmentActions";


const Appointment = element => {
  const { options, params } = element;

  const userInterface = Boolean(
    params.id &&
    (
      options.book || 
      options.cancel || 
      options.create || 
      options.reserve || 
      options.reschedule || 
      options.noshow ||
      !options.hasOwnProperty('confirm')
    )
  );
  
  if (userInterface === false) {
    if (!options.hasOwnProperty('confirm')) {
      ConfirmAppointment(element, params.id)
        .then(console.log)
    }

    return null
  }

  return (
    <>Form</>
  )
}

export default Appointment
